module.exports = __webpack_public_path__ + "static/media/s51.a0ef8d4c.jpg";